import ShopTable from './ShopTable';

export * from './ShopTable';
export default ShopTable;
